/* @generated */

// src/assets/ui-icon/line/info-small.tsx
import * as React from "react";
var InfoSmallLine = (props) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 24 24", fill: "none", ...props }, /* @__PURE__ */ React.createElement(
  "path",
  {
    d: "M11.75 10.5a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Zm0 .965c-.265 0-.515-.025-.75-.06V14.5h1.5v-3.095c-.235.035-.485.06-.75.06Z",
    fill: "currentColor",
    vectorEffect: "non-scaling-stroke"
  }
), /* @__PURE__ */ React.createElement(
  "path",
  {
    d: "M11.75 18c-3.97 0-6.25-2.28-6.25-6.25S7.78 5.5 11.75 5.5 18 7.78 18 11.75 15.72 18 11.75 18Zm0-11C8.6 7 7 8.6 7 11.75s1.6 4.75 4.75 4.75 4.75-1.6 4.75-4.75S14.9 7 11.75 7Z",
    fill: "currentColor",
    vectorEffect: "non-scaling-stroke"
  }
));
export {
  InfoSmallLine
};
